import api from 'api';
import { BuzzCards } from 'records/BuzzCard';

export const BUZZ_ITEM_ASYNC_ACTION_START = 'BUZZ_ITEM_ASYNC_ACTION_START';
export const BUZZ_ITEM_ASYNC_ACTION_ERROR = 'BUZZ_ITEM_ASYNC_ACTION_ERROR';
export const BUZZ_ITEM_ASYNC_ACTION_SUCCESS = 'BUZZ_ITEM_ASYNC_ACTION_SUCCESS';
export const BUZZ_ITEM_ASYNC_UPDATE_ACTION_SUCCESS = 'BUZZ_ITEM_ASYNC_UPDATE_ACTION_SUCCESS';
export const BUZZ_ITEM_RESET_STATE = 'BUZZ_ITEM_RESET_STATE';

function buzzCardAsyncActionStart() {
  return {
    type: BUZZ_ITEM_ASYNC_ACTION_START,
  };
}

function buzzCardAsyncActionSuccess(data) {
  return {
    type: BUZZ_ITEM_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function buzzCardAsyncActionError(error) {
  return {
    type: BUZZ_ITEM_ASYNC_ACTION_ERROR,
    error,
  };
}


function buzzCardAsyncUpdateSuccess(data) {
  return {
    type: BUZZ_ITEM_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}


export function resetDesignItemState() {
  return {
    type: BUZZ_ITEM_RESET_STATE,
  };
}

export function getBuzzCardAsync(designid) {
  return (dispatch, getState) => {
    dispatch(buzzCardAsyncActionStart());
    return api.request(`design/buzzcard?designId=${ designid }`, 'get')
    .then((data) => {
      dispatch(buzzCardAsyncActionSuccess(data));
      return BuzzCards(data);
    })
    .catch((err) => {
      dispatch(buzzCardAsyncActionError('Unable to get buzz card'));
      throw (err);
    });
  };
}

export function updateBuzzCardAsync(buzzCard) {
  return (dispatch, getState) => {
    dispatch(buzzCardAsyncActionStart());
    return api.request('design/buzzcard', 'put', buzzCard)
    .then((data) => {
      dispatch(buzzCardAsyncUpdateSuccess(data));
      return BuzzCards(data);
    })
    .catch((err) => {
      dispatch(buzzCardAsyncActionError('Unable to update buzz card'));
      throw (err);
    });
  };
}

export function createBuzzCardAsync(buzzCard) {
  return (dispatch, getState) => {
    dispatch(buzzCardAsyncActionStart());
    return api.request('design/buzzcard', 'post', buzzCard)
    .then((data) => {
      dispatch(buzzCardAsyncActionSuccess(data));
      return BuzzCards(data);
    })
    .catch((err) => {
      dispatch(buzzCardAsyncActionError('Unable to create buzz card'));
      throw (err);
    });
  };
}
